<template>
  <div>
    <div class="text-center">
      <Button _key="btnArchive" title="Confirmar" color="white" backGroundColor="#453db4" size="small"
        :clicked="update" />
    </div>
  </div>
</template>
<script>
import Button from "@nixweb/nixloc-ui/src/component/forms/Button.vue";

import { mapMutations, mapActions } from "vuex";

export default {
  name: "RentArchive",
  props: {
    rent: String,
  },
  components: {
    Button,
  },
  data() {
    return { urlUpdate: "/api/v1/rental/rent/archive" };
  },
  methods: {
    ...mapActions("generic", ["putApi"]),
    ...mapMutations("generic", ["addEvent", "hideModal", "removeLoading"]),
    update() {
      let params = { url: this.urlUpdate, obj: { id: this.rent.id } };
      this.putApi(params).then((response) => {
        if (response.success) {
          this.addEvent({ name: "rentArchive" });
          this.hideModal();
        }
        this.removeLoading(["btnArchive"]);
      });
    },
  },
};
</script>